import React from "react";
import * as Option from "fp-ts/lib/Option";
import { ContentCollectionHorizontal } from "contentCollection";
import { config } from "core/utils";
import { isCardFixed } from "pages/utils";
function isExtraCompatible(program, field) {
    return (field === "extra" &&
        program.extra !== null &&
        program.extra.items.length > 0);
}
function isExtra2Compatible(program, field) {
    return (field === "extra2" &&
        program.extra2 !== null &&
        program.extra2.items.length > 0);
}
function isExtra3Compatible(program, field) {
    return (field === "extra3" &&
        program.extra3 !== null &&
        program.extra3.items.length > 0);
}
function isExtra4Compatible(program, field) {
    return (field === "extra4" &&
        program.extra4 !== null &&
        program.extra4.items.length > 0);
}
function isExtra5Compatible(program, field) {
    return (field === "extra5" &&
        program.extra5 !== null &&
        program.extra5.items.length > 0);
}
function isExtra6Compatible(program, field) {
    return (field === "extra6" &&
        program.extra6 !== null &&
        program.extra6.items.length > 0);
}
function isExtra7Compatible(program, field) {
    return (field === "extra7" &&
        program.extra7 !== null &&
        program.extra7.items.length > 0);
}
function isExtra8Compatible(program, field) {
    return (field === "extra8" &&
        program.extra8 !== null &&
        program.extra8.items.length > 0);
}
export var block = function (componentId, field) {
    return function (data) {
        if (isExtraCompatible(data, field)) {
            return getBlock(componentId, data.extra, config.tracking.listNames.extra, data.fetchingData);
        }
        if (isExtra2Compatible(data, field)) {
            return getBlock(componentId, data.extra2, config.tracking.listNames.extra2, data.fetchingData);
        }
        if (isExtra3Compatible(data, field)) {
            return getBlock(componentId, data.extra3, config.tracking.listNames.extra3, data.fetchingData);
        }
        if (isExtra4Compatible(data, field)) {
            return getBlock(componentId, data.extra4, config.tracking.listNames.extra4, data.fetchingData);
        }
        if (isExtra5Compatible(data, field)) {
            return getBlock(componentId, data.extra5, config.tracking.listNames.extra5, data.fetchingData);
        }
        if (isExtra6Compatible(data, field)) {
            return getBlock(componentId, data.extra6, config.tracking.listNames.extra6, data.fetchingData);
        }
        if (isExtra7Compatible(data, field)) {
            return getBlock(componentId, data.extra7, config.tracking.listNames.extra7, data.fetchingData);
        }
        if (isExtra8Compatible(data, field)) {
            return getBlock(componentId, data.extra8, config.tracking.listNames.extra8, data.fetchingData);
        }
        return Option.none;
    };
};
function getBlock(componentId, data, listName, fetchingData) {
    return Option.some({
        key: data.uuid,
        View: function () { return (React.createElement(ContentCollectionHorizontal, { componentId: componentId, listName: listName, title: data.title || "", items: data.items.filter(isCardFixed), uuid: data.uuid, trackingEnabled: !fetchingData })); },
    });
}
